import React from 'react'
import { makeStyles } from '@mui/styles'

import lang from '@/lang'
import ApproveWrapper from './approve-wrapper'

const Pending = () => {
  const classes = useStyles()

  return (
    <ApproveWrapper title={lang.approveTitle}>
      <p className={classes.subtitle}>{lang.approveDescription1}</p>
      <p className={classes.subtitle}>{lang.approveDescription2}</p>
    </ApproveWrapper>
  )
}

const useStyles = makeStyles(theme => ({
  subtitle: {
    textAlign: 'center',
  },
}))

export default Pending
